import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import RequestCard from '../components/RequestCard';

const PelayananPage = () => {
  const navigate = useNavigate();
  const serviceTypes = [
    {
      id: 'rekap',
      title: 'Rekap',
      description: 'Lihat rekap informasi',
      icon: '📊',
      color: '#e8f1fd'
    },
    {
      id: 'obat',
      title: 'Obat',
      description: 'Daftar obat dan layanan kesehatan',
      icon: '💊',
      color: '#e6f8f5'
    },
    {
      id: 'dm-pamong',
      title: 'DM Pamong',
      description: 'Kirim WhatsApp ke pamong',
      icon: '💬',
      color: '#fff3e0'
    },
    {
      id: 'panduan-doa',
      title: 'Panduan Doa',
      description: 'Lihat kumpulan doa dan panduan ibadah',
      icon: '🙏',
      color: '#feeeee'
    }
  ];

  const handleCardClick = (serviceId) => {
    console.log(`Clicked on ${serviceId} service`);
    
    if (serviceId === 'panduan-doa') {
      navigate('/panduan-doa');
    } else if (serviceId === 'obat') {
      navigate('/obat');
    } else if (serviceId === 'dm-pamong') {
      // Open WhatsApp chat with the specified number in a new tab
      const phoneNumber = '6281548011463'; // Format without spaces or dashes for WhatsApp link
      const whatsappUrl = `https://wa.me/${phoneNumber}`;
      window.open(whatsappUrl, '_blank');
    } else if (serviceId === 'rekap') {
      navigate('/rekap');
    } else {
      // Other services are still in development
      alert(`Fitur ${serviceId} sedang dalam pengembangan`);
    }
  };
  
  return (
    <PageContainer>
      <PageHeader>
        <h1>Pelayanan</h1>
        <p>Pilih layanan yang ingin diakses</p>
      </PageHeader>
      
      <ServiceGrid>
        {serviceTypes.map(service => (
          <RequestCard
            key={service.id}
            title={service.title}
            description={service.description}
            icon={service.icon}
            color={service.color}
            onClick={() => handleCardClick(service.id)}
          />
        ))}
      </ServiceGrid>
    </PageContainer>
  );
};

const PageContainer = styled.div`
  padding: 1.5rem;
  max-width: 1280px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    padding: 1rem 0.5rem;
  }
`;

const PageHeader = styled.div`
  margin-bottom: 2rem;
  
  h1 {
    font-size: 1.75rem;
    font-weight: 600;
    color: var(--text-dark);
    margin-bottom: 0.5rem;
  }
  
  p {
    color: var(--text-light);
  }
`;

const ServiceGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
  margin-bottom: 2.5rem;
  
  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

export default PelayananPage;